import * as React from 'react';
import axios from "axios";
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from "../context/AuthContext";
import Button from '@mui/material/Button';
import { SvgIcon } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTranslation } from "react-i18next";
import config from '../config.js';
import { useSnackbar } from 'notistack';

export default function EditProjectDialog({ setOpen, open, projectSelected, reloadProjects }) {

    const {  t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const {jwt} = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setTitleNew(projectSelected.attributes.title);
        setDescriptionNew(projectSelected.attributes.description);
    }, [projectSelected]);

    const [titleNew, setTitleNew] = useState(projectSelected.attributes.title);
    const [descriptionNew, setDescriptionNew] = useState(projectSelected.attributes.description);

    const handleClose = () => {
        setOpen(false);
    };

    const handleEdit = () => {
        setOpen(false);
            const dataForm = new FormData();
            dataForm.append('data', JSON.stringify({
                title: titleNew,
                description: descriptionNew,
            }))
            axios.put(`${config.apiUrl}/api/projects/${projectSelected.id}`, dataForm, {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                }
            })
                .then(res => {
                    setIsLoading(false);
                    enqueueSnackbar(`${t("successEditProject")}`, {variant:'success'} );
                    reloadProjects();
                })
                .catch(err => {
                    enqueueSnackbar(`${t("errorEditProject")}`, {variant:'error'} );
                });
        
    };

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth='sm' fullWidth={true}>
                <Box sx={{ p: 3 }}>
                    <DialogTitle>
                        <Typography variant="h4" component={"div"}>
                            {t("EditProject")}
                        </Typography>
                    </DialogTitle>
                    <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 16,
                        top: 16,
                        color: theme.palette.grey[500],
                    })}
                    >
                    <CancelIcon />
                    </IconButton>
                    <DialogContent>
                        <DialogContentText component={"div"}>
                            <Typography
                                color="text.secondary"
                                variant="body2"
                            >
                                {t("PleaseModify")}
                            </Typography>
                        </DialogContentText>
                        <Stack spacing={3} sx={{ mt: 3 }}>
                            <TextField
                                fullWidth
                                label={t("NewTitle")}
                                name="title"
                                type="text"
                                value={titleNew}
                                onChange={(event) => { setTitleNew(event.target.value) }}
                            />
                            <TextField
                                fullWidth
                                label={t("NewDescription")}
                                name="description"
                                type="text"
                                multiline
                                rows={3}
                                value={descriptionNew}
                                onChange={(event) => { setDescriptionNew(event.target.value) }}
                            />
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button startIcon={(
                        <SvgIcon fontSize="medium">
                            <SaveIcon />
                        </SvgIcon>
                    )} 
                    variant="contained" onClick={handleEdit}>{isLoading ? `${t("Saving")} ...` : `${t("Save")}`}</Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </>
    );
}